import React from "react";
import { Segment, Form } from "semantic-ui-react";
import { useIntl } from "react-intl";

interface PatientIdentificationProps {
  patientInfo?: Record<string,any>;
}

const DEFAULT_PROPS = {
  patientInfo: {},
};

const PatientIdentification = (propsParam: PatientIdentificationProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };
  const intl = useIntl();
  return (
    <Segment>
      <Form>
        <Form.Group inline>
          <Form.Button circular size="mini" icon="user" />
          <Form.Input
            label="HN"
            readOnly
            width={3}
            value={props.patientInfo?.hn ? props.patientInfo.hn : ""}
          />
          <Form.Input
            label={intl.formatMessage({ id: "ชื่อผู้ป่วย" })}
            readOnly
            width={6}
            value={
              props.patientInfo?.full_name_th
                ? props.patientInfo.full_name_th
                : ""
            }
          />
          <Form.Input
            label={intl.formatMessage({ id: "เพศ" })}
            readOnly
            width={2}
            value={props.patientInfo?.gender ? props.patientInfo.gender : ""}
          />
          <Form.Input
            label={intl.formatMessage({ id: "เกิด" })}
            readOnly
            width={3}
            value={
              props.patientInfo?.birthdate ? props.patientInfo.birthdate : ""
            }
          />
          <Form.Input
            label={intl.formatMessage({ id: "อายุ" })}
            readOnly
            width={2}
            value={props.patientInfo?.age ? props.patientInfo.age : ""}
          />
        </Form.Group>
      </Form>
    </Segment>
  );
};

export default React.memo(PatientIdentification);
